import { render, staticRenderFns } from "./JediPledge.vue?vue&type=template&id=c2ef66dc&scoped=true&"
import script from "./JediPledge.vue?vue&type=script&lang=js&"
export * from "./JediPledge.vue?vue&type=script&lang=js&"
import style0 from "./JediPledge.vue?vue&type=style&index=0&id=c2ef66dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ef66dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ef66dc')) {
      api.createRecord('c2ef66dc', component.options)
    } else {
      api.reload('c2ef66dc', component.options)
    }
    module.hot.accept("./JediPledge.vue?vue&type=template&id=c2ef66dc&scoped=true&", function () {
      api.rerender('c2ef66dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/steps/JediPledge.vue"
export default component.exports